import type { Data } from '@strapi/types';
import { useAppContext } from '@/modules/app-context/use-app-context';
import { generateRedirectUrl } from '@/modules/utils/redirect-url';
import { useAuth } from '@power-core/toolkit';

export const useOpenDocument = () => {
	const { auth } = useAuth();
	const { appConfig, documentTypeURLS } = useAppContext();

	const openDocument = async ({
		documentTypeName,
		documentId,
		accessLevel,
		region,
	}: {
		documentTypeName: Data.Entity<'api::document-type.document-type'>['title'];
		documentId: Data.Entity<'api::project-document.project-document'>['documentId'];
		accessLevel?: Data.Entity<'api::document-access.document-access'>['accessLevel'];
		region?: Data.Entity<'api::project-document.project-document'>['region'];
	}) => {
		if ((!documentId && !accessLevel) || !documentTypeURLS || !documentTypeName) {
			console.warn(
				`Missing required parameters to open document: documentId: ${documentId}, accessLevel: ${accessLevel}, documentTypeURLS: ${documentTypeURLS}, documentTypeName: ${documentTypeName}`,
			);
			return;
		}

		generateRedirectUrl({
			url: documentTypeURLS[documentTypeName] ?? '',
			documentId,
			toolUrl: appConfig.appName,
			user: auth?.data?.user?.email ?? '',
			...(region ? { region: region || 'IEC' } : {}),
			...(accessLevel ? { accessLevel } : {}),
		});
	};

	return openDocument;
};
